import { CtgListOrderingKey } from "@/components/business/CtgListContainer/ctgList.types";
import { useCtgListFilterState } from "@stores/ctgList";

import {
  ORDERING_TABLE,
  Ordering,
  TABLE_HEADER_LIST,
  TableHeaderList,
} from "../../../constants/ctgListTable.constants";

interface UseHandleCtgListTableOrderingReturn {
  tableHeaderList: TableHeaderList[];
  handleOrdering: (
    orderingTitle: CtgListOrderingKey,
    ordering: Ordering,
  ) => void;
  getOrderingIcon: (ordering: Ordering) => string;
  checkIsOrdering: (ordering: Ordering) => boolean;
}

export const useHandleCtgListTableOrdering =
  (): UseHandleCtgListTableOrderingReturn => {
    const [ctgListFilter, setCtgListFilter] = useCtgListFilterState();
    const { order } = ctgListFilter;

    const tableHeaderList: TableHeaderList[] = TABLE_HEADER_LIST.map(
      (tableHeader) => {
        const orderingValue = order[tableHeader.orderingTitle] || "none";
        return {
          ...tableHeader,
          ordering: orderingValue,
        };
      },
    );

    const handleOrdering = (
      orderingTitle: CtgListOrderingKey,
      ordering: Ordering,
    ) => {
      const updatedOrdering = ORDERING_TABLE[ordering];
      let updatedOrderObject = { ...order };

      if (orderingTitle in order) {
        delete updatedOrderObject[orderingTitle];
      }

      updatedOrderObject = {
        ...updatedOrderObject,
        [orderingTitle]: updatedOrdering,
      };

      if (updatedOrdering === "none") {
        delete updatedOrderObject[orderingTitle];
      }
      setCtgListFilter({
        ...ctgListFilter,
        order: updatedOrderObject,
      });
    };

    const getOrderingIcon = (ordering: Ordering) => {
      if (ordering === "asc") return "▲";
      if (ordering === "desc") return "▼";
      return "";
    };

    const checkIsOrdering = (ordering: Ordering) => {
      if (ordering === "none") return false;
      return true;
    };

    return {
      tableHeaderList,
      handleOrdering,
      getOrderingIcon,
      checkIsOrdering,
    };
  };
